import React from 'react';
import BonusI from '../BonusI';

const BonusIcon = ({ icon, title }) => {
    return <BonusI className={ icon } title={title}></BonusI>;
};

export default BonusIcon;